const findStartIndex = (text: string, matchIndex: string | number, maxLengthBefore: number) => {
  const index = Number(matchIndex);
  if (index <= maxLengthBefore) {
    return { startIndex: 0, prefix: '' };
  }

  let startIndex = index - maxLengthBefore;
  const spaceIndex = text.indexOf(' ', startIndex);

  if (spaceIndex !== -1 && spaceIndex < index) {
    startIndex = spaceIndex + 1;
  }

  return { startIndex, prefix: '...' };
};

export const getHighlightedTextParts = (text: string, highlight: string) => {
  const lowerText = text.toLowerCase();
  const lowerHighlight = highlight.toLowerCase();
  const index = lowerText.indexOf(lowerHighlight);

  if (index === -1) {
    return { before: text, match: '', after: '' };
  }

  const maxLengthBefore = 20;
  const { startIndex, prefix } = findStartIndex(text, index, maxLengthBefore);

  const before = prefix + text.substring(startIndex, index);
  const match = text.substring(index, index + highlight.length);
  const after = text.substring(index + highlight.length);

  return { before, match, after };
};
